import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evidence',
  templateUrl: './evidence.component.html',
})
export class EvidenceComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
